import { render, staticRenderFns } from "./ListBillHistory.vue?vue&type=template&id=89b16488&scoped=true"
import script from "./ListBillHistory.vue?vue&type=script&lang=js"
export * from "./ListBillHistory.vue?vue&type=script&lang=js"
import style0 from "./ListBillHistory.vue?vue&type=style&index=0&id=89b16488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b16488",
  null
  
)

export default component.exports